import { Icon } from './Icon';

export interface ToastMessage {
  id: number;
  text: string;
  tone: 'success' | 'error' | 'info';
}

export function ToastRegion({ toasts, dismiss }: { toasts: ToastMessage[]; dismiss: (id: number) => void }) {
  return <div className="toast-region" aria-live="polite" aria-atomic="false">
    {toasts.map((toast) => <div className={`toast toast--${toast.tone}`} key={toast.id} role={toast.tone === 'error' ? 'alert' : 'status'}>
      <Icon name={toast.tone === 'success' ? 'check' : toast.tone === 'error' ? 'warning' : 'film'} size={18} />
      <span>{toast.text}</span>
      <button type="button" onClick={() => dismiss(toast.id)} aria-label="Dismiss notification"><Icon name="close" size={16} /></button>
    </div>)}
  </div>;
}
